export function _setHTML(el) {
  return function (html) {
      return function() {
          el.innerHTML = html;
      };
  };
};
